"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const VideoPlayer_1 = __importDefault(require("../../../../common/components/Other/VideoPlayer"));
const VideoPageContainer = styled_components_1.default.div `
  height: 100%;
  background-color: ${props => props.theme.palette.mainAppColor.main};

  animation-duration: ${(props) => props.fadeInContentAnimation * 1}s;

  .video-holder {
    height: 100%;
    animation-delay: ${(props) => props.fadeInContentAnimation * 1}s;
    animation-duration: ${(props) => props.fadeInVideoAnimation * 1}s;

    &.fading-out {
      animation-delay: 0s;
      animation-duration: ${(props) => props.fadeOutVideoAnimation * 1}s;
    }
  }
`;
const FADE_IN_VIDEO = 4 * 1000;
const FADE_OUT_VIDEO = 1 * 1000;
const DetailPage = (props) => {
    const { content, openNextSlide, settings } = props;
    const video = content.videos[0];
    const fadeOutVideoTimeout = (0, react_1.useRef)(null);
    const [videoLoaded, setVideoLoaded] = (0, react_1.useState)(false);
    const [hasError, setHasError] = (0, react_1.useState)(false);
    const { speed } = settings;
    const clearTimeouts = () => {
        clearTimeout(fadeOutVideoTimeout.current);
    };
    const handleNextSlide = () => {
        if (!settings.stopSlideShow) {
            openNextSlide();
        }
    };
    const handleVideoEnd = () => {
        document.getElementsByClassName('video-holder')[0].classList.add('animate__fadeOut');
        document.getElementsByClassName('video-holder')[0].classList.add('fading-out');
        fadeOutVideoTimeout.current = setTimeout(() => {
            handleNextSlide();
        }, FADE_OUT_VIDEO / speed);
    };
    const handleVideoError = () => {
        setHasError(true);
        handleNextSlide();
    };
    const handleVideoReady = () => {
        setVideoLoaded(true);
    };
    (0, react_1.useEffect)(() => {
        return () => {
            clearTimeouts();
        };
    }, []);
    (0, react_1.useEffect)(() => {
        clearTimeouts();
        setVideoLoaded(false);
        setHasError(false);
    }, [content]);
    if (hasError) {
        return null;
    }
    return (react_1.default.createElement(VideoPageContainer, { className: "video-page-container animate__animated animate__fadeIn", fadeInContentAnimation: settings.fadeInContentTime / 1000, fadeInVideoAnimation: FADE_IN_VIDEO / speed / 1000, fadeOutVideoAnimation: FADE_OUT_VIDEO / speed / 1000 },
        react_1.default.createElement("div", { className: "video-holder animate__animated animate__fadeIn" },
            react_1.default.createElement(VideoPlayer_1.default, { video: video, onVideoEnd: handleVideoEnd, onVideoError: handleVideoError, onVideoReady: handleVideoReady })),
        !videoLoaded && !hasError && react_1.default.createElement("div", { className: "loading-placeholder" }, "Loading video...")));
};
exports.default = DetailPage;
